import React from 'react'
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from 'recharts'
import Widget from '../Widget'
import withFetch from '../../../infrastructure/withFetch'
import Subtitle from '../../../components/Subtitle'
import Box from '../../../components/Box'

const buildQuery = (eventId, startDate, endDate) =>
    `/api/sales/get-customers-by-age/${eventId}?startDate=${startDate}&endDate=${endDate}`

const CustomTooltip = ({ active, payload, label }) => {
    if (active) {
        return (
            <div className="custom-tooltip">
                <span>
                    <strong>{label}</strong>
                </span>
                <span style={{ marginLeft: 10 }}>{payload[0].value}</span>
            </div>
        )
    }

    return null
}

const GetCustomerAge = withFetch(
    props => buildQuery(props.eventId, props.startDate, props.endDate),
    ({ status, data, retry }) => {
        return (
            <Widget data={data} status={status} retry={retry}>
                <ResponsiveContainer width={'100%'} height={350}>
                    <BarChart
                        width={300}
                        height={200}
                        margin={{ top: 20, left: 20, bottom: 20, right: 20 }}
                        data={data}
                        fontSize={11}
                        fontFamily={'Open Sans'}
                        layout={'vertical'}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis type={'number'} />
                        <YAxis type={'category'} dataKey={'ageRange'} />
                        <Bar dataKey={'totalSold'} fill={'rgb(71, 144, 193)'} />
                        <Tooltip content={CustomTooltip} cursor={null} />
                    </BarChart>
                </ResponsiveContainer>
            </Widget>
        )
    },
)

const customerAgeTooltip = (
    <div>
        <p>
            Customers’ age at date of event. Where more than one ticket is
            purchased on a single order, only the primary customer account
            holder’s age is listed.
        </p>
    </div>
)

const CustomerAge = ({ eventId, startDate, endDate }) => (
    <div>
        <Subtitle title="Customers by Age" tooltip={customerAgeTooltip} />
        <Box>
            <div style={{ minHeight: 320 }}>
                <GetCustomerAge
                    eventId={eventId}
                    startDate={startDate}
                    endDate={endDate}
                />
            </div>
        </Box>
    </div>
)

export default CustomerAge
